import { USER_CONVERSATION } from "../apiConstant";
import BaseApi from "../baseApi";

class UserConversationApi extends BaseApi {
  getListUserConversation(param) {
    return this.post(`${USER_CONVERSATION}/${param?.conversationId}`, param);
  }

  getList(param) {
    return this.post(`${USER_CONVERSATION}/list`, param);
  }

  updateConversation(param) {
    return this.post(`${USER_CONVERSATION}/update-conversation`, param);
  }

  getUserFromConversation(param) {
    return this.get(
      `${USER_CONVERSATION}/member-from-conversation/${param.conversationId}/${param.skip}/${param.limit}`,
    );
  }

  addMemberInConversation(param) {
    return this.post(`${USER_CONVERSATION}/add-more-user`, param);
  }

  removeUser(param) {
    return this.post(`${USER_CONVERSATION}/remove-users`, param);
  }

  exitGroup(param) {
    return this.post(`${USER_CONVERSATION}/${param?.conversationId}/exit`);
  }

  getMembersReadUnread(param) {
    return this.post(`${USER_CONVERSATION}/user-read-unread`, param);
  }

  updateRoleForMember(param) {
    return this.post(`${USER_CONVERSATION}/update-role`, param);
  }

  partnership(param) {
    return this.get(`${USER_CONVERSATION}/partner-ship/${param}`);
  }

  markAsRead() {
    return this.post(`${USER_CONVERSATION}/mark-as-read`);
  }

  getUnread() {
    return this.get(`${USER_CONVERSATION}/get-unread`);
  }

  getScheduleConversations() {
    return this.get(`${USER_CONVERSATION}/schedule-conversation`);
  }
}
export default UserConversationApi;
